import React from "react";
import Modal from "../ui/Modal";

interface YesToolsClassSelectionModalProps {
  isOpen: boolean;
  selectedClassLevel: string;
  selectedGraduateTrack: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  graduateTrackOptions: ReadonlyArray<{ value: string; label: string }>;
  showGraduateTrackSelect: boolean;
  helperText?: string;
  errorText?: string;
  saving?: boolean;
  onChange: (value: string) => void;
  onGraduateTrackChange: (value: string) => void;
  onConfirm: () => void;
}

export default function YesToolsClassSelectionModal({
  isOpen,
  selectedClassLevel,
  selectedGraduateTrack,
  options,
  graduateTrackOptions,
  showGraduateTrackSelect,
  helperText,
  errorText,
  saving = false,
  onChange,
  onGraduateTrackChange,
  onConfirm,
}: YesToolsClassSelectionModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      title="Sınıfınızı seçiniz"
      size="sm"
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEscape={false}
    >
      <div className="space-y-4">
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
          YES.Tools hesabınızla devam edebilmek için lütfen sınıfınızı seçiniz.
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-gray-700">Sınıf</label>
          <select
            value={selectedClassLevel}
            onChange={(e) => onChange(e.target.value)}
            disabled={saving}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-gray-800 transition-all focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <option value="">Sınıf seçiniz</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {helperText && (
            <p className="mt-2 text-xs text-gray-500">{helperText}</p>
          )}
          {errorText && (
            <p className="mt-2 text-xs text-red-600">{errorText}</p>
          )}
        </div>

        {showGraduateTrackSelect && (
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Alan</label>
            <select
              value={selectedGraduateTrack}
              onChange={(e) => onGraduateTrackChange(e.target.value)}
              disabled={saving}
              className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-gray-800 transition-all focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <option value="">Alan seçiniz</option>
              {graduateTrackOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <button
          type="button"
          onClick={onConfirm}
          disabled={saving || !selectedClassLevel || (showGraduateTrackSelect && !selectedGraduateTrack)}
          className="w-full rounded-xl bg-purple-600 px-4 py-3 font-semibold text-white shadow-lg shadow-purple-600/20 transition-all hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-500/20 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {saving ? "Kaydediliyor..." : "Devam Et"}
        </button>
      </div>
    </Modal>
  );
}
